import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";
import AdminDashboardMenuWrapper from "@/components/admin/admin-dashboard-menu-wrapper";
import InactiveNotice from "@/components/tutor/inactive-notice";
import GradCapLoader from "@/components/ui/grad-cap-loader";

import { useAuth } from "@/services/auth/auth-context";

import { useMyStaffData } from "@/services/entities/use-staff";

export const Route = createFileRoute("/admindashboard/_layout")({
  component: RouteComponent,
});

function RouteComponent() {
  const { isAdmin, isLoading, error, authUser } = useAuth();
  const { staff, isLoading: dataLoading } = useMyStaffData();

  // Show loading while checking admin status
  if (isLoading || dataLoading) {
    console.log("Loading auth groups...");
    return <GradCapLoader />;
  }

  // Redirect if not authenticated
  if (!authUser) {
    console.log("Not authenticated, redirecting to login...");
    return <Navigate to="/login" search={{ from: "/admindashboard" }} />;
  }

  // Handle errors
  if (error) {
    console.error("Error loading auth groups:", error);
    return <Navigate to="/login" search={{ from: "/admindashboard" }} />;
  }

  // Handle unauthorized (not admin)
  if (!isAdmin) {
    console.log("User is not an admin, redirecting...");
    return <Navigate to="/login" search={{ from: "/admindashboard" }} />;
  }

  if (staff?.is_active === false) {
    return <InactiveNotice />;
  }

  // Render admin dashboard for authenticated admins
  console.log("Rendering admin dashboard...");
  return (
    <AdminDashboardMenuWrapper>
      <Outlet />
    </AdminDashboardMenuWrapper>
  );
}
